import axios from 'axios';
import {PROFILE_LOAD} from './AppTemplateActions';
import {getBaseApiUrl, getPublicUrl} from '../../common/AppContextTools';

export const ALERT = 'ALERT';
export const ERROR = 'ERROR';
export const LOADING = 'LOADING';
export const LOADED = 'LOADED';

export const setupAxios = () => async (dispatch, getState) => {
    // don't change starts with (as we are replacing whole LOCALHOST phrase)
    axios.defaults.baseURL = getBaseApiUrl();

    axios.interceptors.request.use(function(config) {
        dispatch(loading());
        const token = getState().appState.token;

        const publicUrl = getPublicUrl();

        if (publicUrl && publicUrl.length > 0) {
            config.params = {
                ...config.params,
                public_url: publicUrl,
            };
        } else if (token != null && !config.anonymous) {
            config.headers.authorization = token.access_token;
        }

        return config;
    }, function(err) {
        dispatch(loaded());
        dispatch(notifyException('Request Error'));
        return Promise.reject(err);
    });
    axios.interceptors.response.use((response) => {
            dispatch(loaded());
            const config = response.config;
            if (config.message) {
                dispatch(notifyMessage(config.message, config.messageParams));
            }
            return response;
        }, (error) => {
            dispatch(loaded());
            const config = error.response ? error.response.config : error.config;
            if (!config.skipAlert) {
                dispatch(notifyException('Server Error'));
            }
            return Promise.reject(error.response);
        },
    );
};

export const mockProfile = () => {
    return {
        type: PROFILE_LOAD,
        profile: {
            email: 'mockprof',
            locale: 'en',
            roles: ['admin'],
        },
    };
};

export const reloadProfile = () => async (dispatch) => {
    const config = {
        url: '/profile',
        errorMessage: 'Something went wrong while loading Profile',
    };
    const result = await axios.request(config);
    dispatch({
        type: PROFILE_LOAD,
        profile: result.data
    });
};

export const loading = () => {
    return {
        type: LOADING,
    };
};

export const loaded = () => {
    return {
        type: LOADED,
    };
};

export const notifyException = (exception) => {
    return {
        type: ERROR,
        alert: {message: 'Something went wrong', params: {exception: exception.toString()}},
    };
};

export const notifyMessage = (message, params = {}) => {
    return {
        type: ALERT,
        alert: {message, params: params},
    };
};


// WEBPACK FOOTER //
// ./src/containers/template/AxiosSetupActions.js